module.exports = __webpack_public_path__ + "img/janopay_creditcard_04.faed52a4.png";